import Page from 'containers/DownloadPage'

export default Page
